import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../services/auth.service';
declare var $: any;

@Component({
  selector: 'app-formulario-registro',
  templateUrl: './formulario-registro.component.html',
  styleUrls: ['./formulario-registro.component.css']
})
export class FormularioRegistroComponent implements OnInit {

  email:string;
  password:string;
  nombre:string;
  apellidos:string;

  constructor(
    public authService: AuthService
  ) { }
 
  registrarse(){
    this.authService.registrar(this.email,this.password, this.nombre, this.apellidos);
  }
  ngOnInit(): void {
    var formInputs = $('input[type="text"],input[type="email"],input[type="password"]');
    formInputs.focus(function() {
         $(this).parent().children('p.formLabel').addClass('formTop');
         $('div#formWrapper').addClass('darken-bg');
         $('div.logo').addClass('logo-active');
    });
    formInputs.focusout(function() {
      if ($.trim($(this).val()).length == 0){
      $(this).parent().children('p.formLabel').removeClass('formTop');
      }
      $('div#formWrapper').removeClass('darken-bg');
      $('div.logo').removeClass('logo-active');
    });
    $('p.formLabel').click(function(){
       $(this).parent().children('.form-style').focus();
    }); 
  }
}
